import { Autocomplete, Box, FormControl, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store';
import { setPageData, setRowsPerPageData } from '../../../global/config/Reducer/staffMemberUseCase.ts';
import { ApiGetClientEntityByClientGroupId, ApiGetManagerScenarioListOfAllocation } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";

function StaffMember_UseCases() {
    const paginationPage = useSelector((state: RootState) => state.StaffMemberUseCasePagination.page)
    const paginationRowsPerPage = useSelector((state: RootState) => state.StaffMemberUseCasePagination.rowsPerPage)
    const [page, setPage] = useState(paginationPage);
    const [rowsPerPage, setRowsPerPage] = useState(paginationRowsPerPage);
    const [datalength, setdatalength] = useState<any>(null);
    const dispatch = useDispatch()
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [selectedEntity, setSelectedEntity] = useState<any>()
    const [allocationData, setAllocationData] = useState<any>()
    const [month, setMonth] = useState<any>(dayjs())



    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
        dispatch(setPageData(newPage))
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        dispatch(setRowsPerPageData(parseInt(event.target.value, 10)))
        dispatch(setPageData(0));
    };

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=JBHIFI`;
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setClientEntityList(res.data);
            setSelectedEntity(res?.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };


    useEffect(() => {
        handleGetClientList()
    }, [])

    const Getdata = async () => {
        try {
            const data = `?clientEntityId=${selectedEntity}&jobMonth=${dayjs(month)?.month() + 1}&jobYear=${dayjs(month)?.year()}&offset=${page * rowsPerPage}&limit=${rowsPerPage}`
            const res = await ApiGetManagerScenarioListOfAllocation(data)
            if (res?.status || res?.success) {
                setAllocationData(res?.data)
                setdatalength(res?.totalVenues)
            }
        } catch (error: any) {
            console.log(error)
            toast.error(error?.message)
        }
    }

    useEffect(() => {
        if (selectedEntity) {
            Getdata()
        }
    }, [selectedEntity, page, rowsPerPage, month])

    return (
        <Box className='p-3 h-100 w-100'>
            <Box className="d-flex flex-wrap align-items-center justify-content-between">
                <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                    <Autocomplete
                        disablePortal
                        id="beacon-autocomplete"
                        options={clientEntityList.filter(
                            (item: any) => item.clientEntityId !== null
                        )} // filter out invalid entries
                        getOptionLabel={(option) => option?.entityName || ""} // properly show label
                        onChange={(event, newValue: any) => {
                            setSelectedEntity(newValue?.clientEntityId || null);
                        }}
                        value={
                            clientEntityList.find(
                                (option: any) => option?.clientEntityId === selectedEntity
                            ) || null
                        }
                        // defaultValue={clientEntityList[0]?.clientEntityId}
                        renderInput={(params) => (
                            <TextField {...params} label="Select Business" />
                        )}
                        size="small"
                    />
                </FormControl>
                <Typography variant='h4' className='text-center mb-4' fontWeight={'bolder'}>Staff Members & Cues</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={month}
                        sx={{ maxWidth: "120px" }}
                        views={['month', 'year']}
                        format="MMM-YY"
                        label="Month"
                        onChange={(value) => {
                            if (!value) return;
                            setMonth(value);
                        }}
                        slots={{
                            openPickerIcon: ArrowDropDownIcon,
                        }}
                    />
                </LocalizationProvider>
            </Box>
            <TableContainer
                component={Paper}
                sx={{ border: "1px solid #ccc" }}
            >
                <Table>
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell>
                                <Typography className='text-white' variant='subtitle2'>Site Name</Typography>
                            </TableCell>
                            <TableCell colSpan={9}>
                                <Typography className='text-white' variant='subtitle2'>Allocations</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allocationData?.length > 0 ? (
                            allocationData?.map((item: any, index: number) => (
                                <TableRow >
                                    <TableCell>
                                        <Typography className='' variant='subtitle2'>{item?.venueName}</Typography>
                                    </TableCell>
                                    {item?.allocations?.map((allocation: any) => (
                                        <TableCell>
                                            <TableRow>{dayjs(allocation?.selectedVisitDate).format("MM-DD-YYYY")}</TableRow>
                                            <TableRow>{allocation?.managerName}</TableRow>
                                            <TableRow>{allocation?.scenarioName}</TableRow>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))

                        ) : (<TableRow><TableCell colSpan={12}><Typography className='text-center'>No Reports Found</Typography></TableCell></TableRow>)
                        }
                    </TableBody>

                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </Box>
    )
}

export default StaffMember_UseCases
